<template>
	<div class="flex flex-col gap-6">
		<section>
			<p class="mb-3">{{ $t("quantity_breaks.packs") }}</p>
			<div class="grid grid-cols-5 lg:grid-cols-4">
				<QuantityOption
					v-for="(option, i) in options"
					:key="option.qtyBreak"
					:is-selected="isSelected(option.qtyBreak)"
					:disabled="disabled"
					:class="cellClass(i + 1)"
					@select="selectQuantity(option.qtyBreak)"
				>
					<template #label>
						<span class="font-bold">{{
							$t("quantity_breaks.pack", { n: option.labelQuantity })
						}}</span>
					</template>
					<template #price>
						<span v-if="option.discountPercent > 0" class="text-sm">
							{{
								$t("quantity_breaks.save_percent", {
									percent: option.discountPercent
								})
							}}
						</span>
					</template>
				</QuantityOption>
			</div>
		</section>
	</div>
</template>

<script setup lang="ts">
import QuantityOption from "./QuantityOption.vue";
import type { MultipackOption } from "~/templates/breadandboxers/composables/useMultipackPricing";

interface Props {
	options: MultipackOption[];
	modelValue: number;
	disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	options: () => [],
	modelValue: 1,
	disabled: false
});

const emit = defineEmits<{
	(e: "update:modelValue", value: number): void;
}>();

const isSelected = (qty: number) => props.modelValue === qty;

const selectQuantity = (qty: number) => {
	if (props.disabled) return;
	emit("update:modelValue", qty);
};

const cellClass = (index: number) => {
	const borderLeftMobile = (index - 1) % 5 === 0;
	const borderLeftDesktop = (index - 1) % 4 === 0;
	const firstRowMobile = index <= 5;
	const firstRowDesktop = index <= 4;
	return [
		borderLeftMobile ? "!border-l-[0.5px]" : "!border-l-0",
		borderLeftDesktop ? "lg:!border-l-[0.5px]" : "lg:!border-l-0",
		firstRowMobile ? "!border-t-[0.5px]" : "!border-t-0",
		firstRowDesktop ? "lg:!border-t-[0.5px]" : "lg:!border-t-0"
	].join(" ");
};
</script>
